import React from "react";
import { withTranslation } from "react-i18next";
import { NIL as NIL_UUID } from "uuid";
import UserAdministrationView from "../../views/user-administration/user-administration.view";
import { LocalStorageService, UserService, DigitalVaultDocumentService } from "../../../services";
import UserAdministrationValidator from "../../../validators/user-administration.validator";
class UserAdministrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      collaboratorListAllow: [],
      inviteListAllow: [],
      user: {},
      usersCollaboratorAdmin: [],
      rolesBySignatureProfile: [],
      // rolesByUser: [],
      token: "",
      shouldRefresh: false,
      optionsFilter: [
        {
          active: 'todos',
          status: this.props.t("userAdministrationView.status.all"),
        },
        {
          active: 'activo',
          status: this.props.t("userAdministrationView.status.active"),
        },
        {
          active: 'inactivo',
          status: this.props.t("userAdministrationView.status.inactive"),
        },
      ],
      message: " ",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      allPermissions: [],
      userSelected: null,
      showDialogDelete: false
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  UserService = new UserService(this.url);
  validators = UserAdministrationValidator(this.props.t);
  digitalVaultDocumentService = new DigitalVaultDocumentService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");

    let usersCollaboratorAdmin =
      await this.UserService.getUsersCollaboratorAdmin(this.token);

    let rolesBySignatureProfile =
      await this.UserService.getRolesSignatureProfile(this.token);
    let filteredRoles = rolesBySignatureProfile;

    usersCollaboratorAdmin = usersCollaboratorAdmin.map((user) => {
      user.status = user.active;
      let nameComplete =
        user.firstName +
        " " +
        user.firstLastName +
        " " +
        user.secondLastName +
        " ";
      user.name = nameComplete;
      user.iconTrashActive = (!user.firstName && !user.firstLastName && user.active) ? true : false
      return user;
    });

    this.getAllPermissionRole()

    try {
      this.setState({
        loading: false,
        user,
        usersCollaboratorAdmin,
        rolesBySignatureProfile: filteredRoles.data,
        token: this.token,
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
    }
  }

  getUserCollaboratorsAdmin = async () => {
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let usersCollaboratorAdmin =
      await this.UserService.getUsersCollaboratorAdmin(this.token);

    usersCollaboratorAdmin.map((user) => {
      let nameComplete =
        user.firstName +
        " " +
        user.firstLastName +
        " " +
        user.secondLastName +
        " ";
      return (user.name = nameComplete);
    });

    this.setState({
      usersCollaboratorAdmin: usersCollaboratorAdmin,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.shouldRefresh !== this.state.shouldRefresh) {
      this.getUserCollaboratorsAdmin();
    }
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function completed dialog

  toggleCompletedRequesting = (
    value,
    message,
    usersCollaboratorAdmin,
    rolesBySignatureProfile
    // rolesByUser
  ) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            usersCollaboratorAdmin: usersCollaboratorAdmin || this.state.usersCollaboratorAdmin,
            rolesBySignatureProfile: rolesBySignatureProfile || this.state.rolesBySignatureProfile,
            // rolesByUser: rolesByUser,
          });
        }, 4000);
      }
    );
  };

  //Funtion error dialog
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  //Funtion warning dialog
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
            message: "",
          });
        }, 5000);
      }
    );
  };

  toggleCompleteCloseDialog = () => {
    this.setState({
      showCompletedRequesting: false,
      message: '',
    })
  }

  getAllPermissionRole = async () => {
    let ENV = process.env
    try {
      let permissionRole = await this.digitalVaultDocumentService.getAllPermissionRole(this.token)
      let noAccessPermiso = {
        id: 0,
        permissions: {
          play: false,
          print: false,
          share: false,
          alerts: false,
          delete: false,
          download: false,
          editMetadata: false,
          generateVersion: false,
          sendMail: false,
          version: false,
          contratcs: false,
          wacth: false,
          upload: false
        },
        roleId: Number(ENV.REACT_APP_COMPANY_ROLE_ID_NO_ACCESS)
      }
      if (permissionRole && permissionRole.data && Number(permissionRole.statusCode) === 200) {
        let permissos = permissionRole.data.map((permiso) => {
          if (permiso.roleId === Number(ENV.REACT_APP_COMPANY_ROLE_ID_ADMIN)) {
            permiso.permissions.contratcs = true
            permiso.permissions.wacth = true
            permiso.permissions.upload = true
          } else if (permiso.roleId === Number(ENV.REACT_APP_COMPANY_ROLE_ID_N1)) {
            permiso.permissions.contratcs = true
            permiso.permissions.wacth = true
            permiso.permissions.upload = true
          } else if (permiso.roleId === Number(ENV.REACT_APP_COMPANY_ROLE_ID_N2)) {
            permiso.permissions.contratcs = true
            permiso.permissions.wacth = true
            permiso.permissions.upload = true
          } else if (permiso.roleId === Number(ENV.REACT_APP_COMPANY_ROLE_ID_N3)) {
            permiso.permissions.contratcs = true
            permiso.permissions.wacth = true
            permiso.permissions.upload = true
          } else {
            permiso.permissions.contratcs = true
            permiso.permissions.wacth = true
          }

          return permiso
        })
        permissos.push(noAccessPermiso)
        this.setState({
          allPermissions: permissos
        })
      } else {
        this.props.history.push("/");
      }
    } catch (error) {
      this.props.history.push("/");
    }
  }

  handleShowDialogDelete = (user) => {
    this.setState({
      showDialogDelete: true,
      userSelected: user
    })
  }

  deleteUser = async () => {
    this.closeShowDialogDelete()
    if (!this.state.userSelected) {
      this.toggleErrorRequesting(true, this.props.t("userAdministrationAction.errors.user.delete"))
      return
    }

    this.toggleLoadingRequesting(true)
    let email = this.state.userSelected.email
    try {
      let deleteUser = await this.UserService.deleteUserInAuth0(email, this.token)
      if (deleteUser && deleteUser.data && Number(deleteUser.statusCode) === 200) {
        this.setState({
          userSelected: null
        })

        let usersCollaboratorAdmin = await this.UserService.getUsersCollaboratorAdmin(this.token)

        let rolesBySignatureProfile = await this.UserService.getRolesSignatureProfile(this.token)
        let filteredRoles = rolesBySignatureProfile;

        usersCollaboratorAdmin = usersCollaboratorAdmin.map((user) => {
          user.status = user.active;
          let nameComplete =
            user.firstName +
            " " +
            user.firstLastName +
            " " +
            user.secondLastName +
            " ";
          user.name = nameComplete;
          user.iconTrashActive = (!user.firstName && !user.firstLastName && user.active) ? true : false
          return user;
        });

        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true, "", usersCollaboratorAdmin, filteredRoles.data)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, this.props.t("userAdministrationAction.errors.general.user.delete"))
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true, this.props.t("userAdministrationAction.errors.general.user.delete"))
    }
  }

  closeShowDialogDelete = () => {
    this.setState({
      showDialogDelete: false,
      userSelected: null
    })
  }

  handleCloseDialogDelete = () => {
    this.setState({
      showDialogDelete: false,

    })
  }

  render() {
    return (
      <UserAdministrationView
        {...this.state}
        history={this.props.history}
        validators={this.validators}
        forceRefresh={this.forceRefresh}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
        deleteUser={this.deleteUser}
        handleCloseDialogDelete={this.handleCloseDialogDelete}
        handleShowDialogDelete={this.handleShowDialogDelete}
        toggleCompleteCloseDialog={this.toggleCompleteCloseDialog}
      />
    );
  }
}

export default withTranslation()(UserAdministrationAction);
